import { CgSpinner } from "react-icons/cg";

const LoadingSpinner = ({
  size = "md",
  className = "",
  text = "",
  message = "",
  minHeight = "",
  fullScreen = false,
}) => {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  const displayText = text || message;

  // If fullScreen or no specific height in className/minHeight, center in middle of screen/section
  const hasHeightInClass = /\b(h-|min-h-)/.test(className);
  const resolvedHeight = fullScreen
    ? "min-h-[70vh]"
    : minHeight
    ? minHeight
    : hasHeightInClass
    ? ""
    : "min-h-[50vh] py-12";

  return (
    <div
      className={`w-full flex-1 flex flex-col items-center justify-center ${resolvedHeight} ${className}`}
    >
      <CgSpinner className={`animate-spin ${sizes[size] || sizes.md} text-primary`} />
      
    </div>
  );
};

export default LoadingSpinner;
